import React, { Fragment } from 'react';

const WheelchairPt4 = () => (
  <Fragment>
    <hr />
    <h4>Accessible Trip FAQs</h4>

    <h5>Where do I meet riders of UberWAV and UberASSIST?</h5>
    <ul className="new-course__body__content__olist--ulist">
      <li>
        It is best to call or text your rider more often before arriving, in case of special requests about the best
        meeting location.
      </li>
      <li>Some riders for example may ask you to drive up their driveway or meet on a non busy intersection.</li>
    </ul>

    <h5>Who uses UberASSIST?</h5>
    <ul className="new-course__body__content__olist--ulist">
      <li>
        UberASSIST is for riders who may need extra assistance such as seniors, those with low seeing or hearing and
        people with mobility restrictions. They may use crutches, service animals, walkers, canes or foldable
        wheelchairs.&nbsp;
      </li>
      <li>
        Riders ordering UberASSIST may require some help or assistance. Always get out of your seat to be ready to
        assist, then listen and ask if help is needed. You may repeat a passenger's instructions to them to be sure you
        have understood them correctly.
      </li>
      <li>When assisting a senior rider, be patient and understanding.&nbsp;</li>
    </ul>

    <h5>When should I start and end an UberWAV or UberASSIST trip?</h5>
    <ul className="new-course__body__content__olist--ulist">
      <li>
        Start the trip as usual but only end the trip after you have helped the customer and you are back in your
        vehicle.
      </li>
    </ul>
    <br />
    <br />
  </Fragment>
);
export default WheelchairPt4;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewWheelchairPt4.js